module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (9).0a999935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (9).jpg
// module id = 348
// module chunks = 0